import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const WheelChart = ({ title, data, onClick }) => {
  const COLORS = [
    'var(--color-primary)',
    'var(--color-success)',
    'var(--color-warning)',
    'var(--color-error)',
    'var(--color-accent)',
    'var(--color-secondary)'
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-md p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground">
            {payload?.[0]?.name}
          </p>
          <p className="text-sm font-data" style={{ color: payload?.[0]?.payload?.fill }}>
            {payload?.[0]?.value?.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 })}
          </p>
          <p className="text-xs text-muted-foreground">
            {((payload?.[0]?.value / data?.reduce((sum, item) => sum + item?.value, 0)) * 100)?.toFixed(1)}%
          </p>
        </div>
      );
    }
    return null;
  };

  const renderColorfulLegendText = (value, entry) => {
    return <span className="text-xs text-foreground" style={{ color: entry?.color }}>{value}</span>;
  };

  return (
    <div 
      className={`bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border transition-smooth hover-lift ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <h4 className="text-sm md:text-base font-medium text-foreground mb-4 font-caption">
        {title}
      </h4>
      <div style={{ width: '100%', height: 250 }} aria-label={`${title} pie chart`}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              formatter={renderColorfulLegendText}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default WheelChart;